export default "__VITE_ASSET__70c6694d__"